module.exports = __webpack_public_path__ + "img/1.00e19b65.png";